/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetCompanyWaProfileImage1$Params {
  wabaPhoneId: string;
}

export function getCompanyWaProfileImage1(http: HttpClient, rootUrl: string, params: GetCompanyWaProfileImage1$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, getCompanyWaProfileImage1.PATH, 'get');
  if (params) {
    rb.path('wabaPhoneId', params.wabaPhoneId, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'image/jpeg', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

getCompanyWaProfileImage1.PATH = '/v1/api/ui/company/wa-profile/{wabaPhoneId}/image';
